import React, {useState, useEffect} from "react";
import {Button, Row, Col, Modal, notification, Table, Icon} from "antd";
import Spinner from "../../spinner";
import {distributionCenterService, trailService, systemService} from "../../../services";
import InputField from "../../input-field";
import { AppContext } from "../../../contexts/app-context";
import { useContext } from "react";
import '../modals.css';
import i18n from "../../../i18n";
import {getTranslatedConstant, unloadPackageTypes} from "../../../helpers/translate.helpers";
import SelectField from "../../select-field";
import NumberInputField from "../../number-input-field";


export default function ModalListUnloadingTime({
    isShow, distCenterId,
    onCloseModal,
    name,
  }) {

  const appContext = useContext(AppContext);

  const [loadingContentModal, setLoadingContentModal] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState(null);

  const [settingsData, setSettingsData] = useState([]);

  const [time, setTime] = useState('');

  const [carcassTypes, setCarcassTypes] = useState([]);
  const [translatedCarcassTypes, setTranslatedCarcassTypes] = useState([]);
  const [carcassTypesLoaded, setCarcassTypesLoaded] = useState(false);

  const [packageTypesList, setPackageTypesList] = useState(null);
  const [translatedPackageTypesList, setTranslatedPackageTypesList] = useState(null);
  const [loadingTypesList, setLoadingTypesList] = useState([]);

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };
  let smallButtonStyle = {
    width: '100%',
    height: '40px',
    background: '#2B3F63',
    position: 'static',
    borderRadius: '10px',
    marginTop: "31px"
  };
  let BackButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#EB5757',
    position: 'static',
    borderRadius: '10px',
    marginBottom: "13px",
    marginTop: "13px"
  };

  const updateTime = (carcassId, packageId, value) => {
    let newSettingsData = [...settingsData];

    newSettingsData.forEach((e, i) => {
        if (e.carcassId === carcassId && e.packageId === packageId) {
          newSettingsData[i].time = value;
          newSettingsData[i].modified = true;
          setSettingsData(newSettingsData);
        }
    });
  };

  useEffect(() => {
    setLoadingTypesList(getTranslatedConstant('loadingTypesList'));
    const translatedCarcassTypes = carcassTypes.map((item) => {
      return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
    });
    setTranslatedCarcassTypes(translatedCarcassTypes);
    if (packageTypesList && packageTypesList.length > 0) {
      const translatedPackageTypes = packageTypesList.map((item) => {
        const type = Object.entries(unloadPackageTypes).filter((itemType) => {
          return itemType[1] === item;
        })[0]
        return {
          Id: item,
          Name: !!type ? i18n.t(`constants.unloadPackageTypes.${type[0]}`) : item
        };
      })
      setTranslatedPackageTypesList(translatedPackageTypes);
    }
  }, [appContext.lang.lang]);

  useEffect(() => {
    if (!carcassTypesLoaded) {
      trailService
        .getTrailTypes()
        .then((response) => {
          const translatedCarcassTypes = response.map((item) => {
            return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
          });
          setCarcassTypes(response);
          setTranslatedCarcassTypes(translatedCarcassTypes);
          setCarcassTypesLoaded(true);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getTrailTypes'),
            description: errorMsg,
          });
        });
    }
    if (!packageTypesList) {
      systemService.getPackageTypes()
        .then((response) => {
          const types = response.map((item) => {
            const type = Object.entries(unloadPackageTypes).filter((itemType) => {
              return itemType[1] === item;
            })[0]
            return {
              Id: item,
              Name: !!type ? i18n.t(`constants.unloadPackageTypes.${type[0]}`) : item
            };
          })
          setPackageTypesList(response);
          setTranslatedPackageTypesList(types);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getPackageTypes'),
            description: errorMsg
          })
        })
    }
  }, []);

  if (isShow && loadingContentModal) {
    distributionCenterService.getUnloadingTimeSettings(distCenterId)
      .then((response) => {
        const settings = response.map((item) => {
          return {
            carcass: item.carcassName,
            package: item.packageName,
            carcassId: item.carcassId,
            packageId: item.packageId,
            time: item.time,
            id: item.id,
            modified: false
          };
        });
        setSettingsData(settings);
        setLoadingContentModal(false);
      })
      .catch((error) => {
        setLoadingContentModal(false);
      });
  }

  // сохранение новых данных о РЦ
  const onClickSave = () => {
    setLoadingContentModal(true);
    const modifiedSettings = settingsData.filter(item => item.modified);
    distributionCenterService.saveUnloadingTimeSettings(distCenterId, modifiedSettings)
      .then((response) => {
        if (response.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.addOrderTimeSum'),
            description: response.message,
          });
          setFieldsErrors(null);
        } else {
          setFieldsErrors(response.errors);
        }
        setLoadingContentModal(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.addOrderTimeSum'),
          description: error,
        });
        setLoadingContentModal(true);
      });
  };

  const columns = [
    {
      title: i18n.t('modals.modalEditUnloadingTimeSettings.table.carcass.title'),
      dataIndex: 'carcass',
      key: 'carcass',
      width: '33%',
    },
    {
      title: i18n.t('modals.modalEditUnloadingTimeSettings.table.package.title'),
      dataIndex: 'package',
      key: 'package',
      width: '33%',
    },
    {
      title: i18n.t('modals.modalEditUnloadingTimeSettings.table.time.title'),
      key: 'time',
      width: '33%',
      render: (record, i) => {
        return <>
            <NumberInputField
              name="time" label={i18n.t('modals.modalEditUnloadingTimeSettings.fields.time.title')}
              value={record.time} 
              setValue={(value) =>{
                updateTime(record.carcassId, record.packageId, value);
              }}
              getFieldErrors={getFieldErrors}
            />
        </>
      },
    }
  ];

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  return (
    <Modal
      title={<span>{i18n.t('modals.modalEditUnloadingTimeSettings.title', {name:name})}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
        setLoadingContentModal(true);
      }}
      width={1140}
      forceRender={true}
      footer={[
        <Button htmlType="submit" key="submit" type="primary" onClick={onClickSave}
                style={bigButtonStyle}>{i18n.t('main.buttons.save')}</Button>,
      ]}
    >
      <Spinner loading={loadingContentModal} label={null}>
        <Table
          style={{minWidth: '100%'}}
          columns={columns}
          className="distribution-centres-table"
          dataSource={settingsData}
          locale={{emptyText: i18n.t('main.empty')}}
          rowKey={(record, index) => ('time-setting-'+index)}
          size="small"
          pagination={false}
        />
      </Spinner>
    </Modal>
  );
}
